import { Route } from "react-router-dom";
import UsersGroupsList from '../views/UsersGroupsList';
import UsersList from '../views/UsersList';
import RolesForm from '../views/RolesForm';
import { UserTypes } from '../../../core/Enums';
import ShiftsCalendar from '../views/ShiftsCalendar';
import ShiftsDepartments from '../views/ShiftsDepartments';
import ShiftsTypes from '../views/ShiftsTypes';
import AccountDetails from '../views/AccountDetails';
import TechGroupsList from '../views/TechGroupsList';
import AccountsMainView from '../views/AccountsMainView';
import UserGroupManage from '../views/UserGroupManage';
import { TechsPage } from '../../system/settings/views/PreferencesPages';
import PausedAccounts from '../views/PausedAccounts';


function AccountsRoutes() {
  let k = 0;
  return (
    [
      <Route key={k++} path="/accounts/manage/:selectedId" element={<AccountDetails />} />,
      <Route key={k++} path="/accounts/manage/:selectedId/:selectedPage" element={<AccountDetails />} />,
      <Route key={k++} path="/accounts/manage/:selectedId/:selectedPage/:selectedAction" element={<AccountDetails />} />,

      <Route key={k++} path="/accounts/usergroup/:selectedId" element={<UserGroupManage />} />,
      <Route key={k++} path="/accounts/usergroup/:selectedId/:selectedPage" element={<UserGroupManage />} />,
      <Route key={k++} path="/accounts/usergroup/:selectedId/:selectedPage/:selectedGroup" element={<UserGroupManage />} />,

      <Route key={k++} path="/accounts/roles/group/:selectedId" element={<RolesForm isGroup />} />,

      <Route key={k++} path="/accounts" element={<AccountsMainView />}>
        <Route path="roles/type/:selectedId" element={<RolesForm isType />} />
        <Route path="admins" element={<UsersList userType={UserTypes.Admin} />} />
        <Route path="admins/:selectedId" element={<UsersList userType={UserTypes.Admin} />} />
        <Route path="agents" element={<UsersList userType={UserTypes.Agent} />} />
        <Route path="agents/:selectedId" element={<UsersList userType={UserTypes.Agent} />} />
        <Route path="technicians" element={<UsersList userType={UserTypes.Technician} />} />
        <Route path="technicians/:selectedId" element={<UsersList userType={UserTypes.Technician} />} />
        <Route path="customers" element={<UsersList userType={UserTypes.Customer} />} />
        <Route path="customers/:selectedId" element={<UsersList userType={UserTypes.Customer} />} />
        <Route path="paused" element={<PausedAccounts />} />
        <Route path="usergroups" element={<UsersGroupsList />} />
        <Route path="usergroups/:selectedId" element={<UsersGroupsList />} />
        <Route path="techgroups" element={<TechGroupsList />} />
        <Route path="techgroups/:selectedId" element={<TechGroupsList />} />
        <Route path="departments" element={<ShiftsDepartments />} />
        <Route path="shift-types" element={<ShiftsTypes />} />
        <Route path="shift-calendar" element={<ShiftsCalendar />} />
        <Route path="shift-calendar/:agentId" element={<ShiftsCalendar />} />
        <Route path="settings/techs" element={<TechsPage />} />
      </Route>

    ]
  );
}

export default AccountsRoutes;
